import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { IAppState } from '../../store/states/app.state';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Utility } from 'src/app/shared/utility/utility';

@Component({
  selector: 'app-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.scss']
})
export class ExampleComponent implements OnInit {
  bsInlineValue = new Date();
  modalRef: BsModalRef;
  modalW1840: BsModalRef;
  modalW1240: BsModalRef;
  modalW640: BsModalRef;
  modalW640v2: BsModalRef;
  PopReservationDate: NgbModalRef;
  @ViewChild('PopReservationDate', { static: true }) PopReservationDateRef: ElementRef;
  modalFAC0006: BsModalRef;
  modalFAC0008: BsModalRef;
  modalFAC0009: BsModalRef;
  modalFAC0010: BsModalRef;
  modalFAC0205: BsModalRef;
  valueInput: any;
  data: any;
  PopQuestionareAnsInp: NgbModalRef;
  valueFAC0012: any;
  lstFacilityReport = [
    { code: '', value: '', active: true },
    { code: '1', value: '本人', active: false },
    { code: '2', value: '家族', active: false }
  ];
  itemSlted = '';
  w380mr20 = 'w380 mr-20';
  w180 = 'w180';
  @ViewChild('PopQuestionareAnsInp', { static: true }) PopQuestionareAnsInpRef: ElementRef;
  constructor(
    private modalService: BsModalService,
    private dialogModalService: DialogModalService,
    public util: Utility,
    private popupService: NgbModal,
    private store: Store<IAppState>
  ) { }

  ngOnInit(): void {
    this.valueInput = {
      HTOrgCode: '00001',
      RsvGender: '1',
      CoCode: '1234567890',
      HTCourseCode: 'C02',
      HTCourseDiv: '1',
      HTSetItemCode: ['1000', '900'],
    };
    this.valueFAC0012 = {
      Date: '20210628',
      Num: '003',
      ScreenCode: '0201',
    };
    this.data =
    {
      HTOrgCode: null,
      ConsulID: 1234567890,
      ConsulName: '受診者氏名',
      KanaName: '受診者氏名',
      DateOfBirth: '60/05/10',
      Gender: '男',
      PhoneNum: '090-1234-5678',
      PostalCode: '01234567890',
      Adress1: null,
      Adress2: null,
      UserID: 12345,
      CoCode: 'CoCode',
      CoName: 'CoName',
      CoOrgName1: 'CoOrgName1',
      CoOrgName2: null,
      EmployeeNum: 'EmployeeNum',
      JoinDate: 0,
      RetireDiv: 'RetireDiv',
      PersonFamilyDiv: 'PersonFamilyDiv',
      InsurerNum: 'InsurerNum',
      InsuranceCardSign: 'InsuranceCardSign',
      InsuranceCardNum: 'InsuranceCardNum',
      InsuranceCardBranchNum: 'InsuranceCardBranchNum',
      Warning1Flg: 'Warning1Flg',
      Warning2Flg: 'Warning2Flg',
      Warning3DispFlg: 'Warning3DispFlg',
      Warning: 'Warning',
      Note: 'Note'
    };
    this.util.addPerfectScrollBar();
  }

  openDetailConditions(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered'
    });
  }

  openModalW1840(template: TemplateRef<any>) {
    this.modalW1840 = this.modalService.show(template, {
      class: ' w1840 modal-dialog-centered'
    });
    this.util.addPerfectScrollBar();
  }
  openModalW1240(template: TemplateRef<any>) {
    this.modalW1240 = this.modalService.show(template, {
      class: ' w1240 modal-dialog-centered'
    });
    this.util.addPerfectScrollBar();
  }
  openModalW640(template: TemplateRef<any>) {
    this.modalW1240 = this.modalService.show(template, {
      class: ' w640 modal-dialog-centered'
    });
  }
  openModalW640v2(template: TemplateRef<any>) {
    this.modalW1240 = this.modalService.show(template, {
      class: ' w640 modal-dialog-centered'
    });
  }
  openModalSuccess() {
    this.dialogModalService.openSuccessModal('メッセージ内容');
  }
  openModalError() {
    this.dialogModalService.openErrorModal('メッセージ内容');
  }
  openModalInfo() {
    this.dialogModalService.openInfoModal('メッセージ内容');
  }
  openModalConfirm() {
    this.dialogModalService.openConfirmModal('メッセージ内容').subscribe((res: DialogResult) => {
      if (res.isOk()) {
      }
    });
  }

  openPopReservationDate() {
    this.PopReservationDate = this.popupService.open(this.PopReservationDateRef, {
      backdrop: 'static', keyboard: false, size: ' w1240', centered: true
    });
  }

  ValueDateSelected(value) {
    if (!value) {
      this.PopReservationDate.close();
    }
  }
  openModalFAC0008(template: TemplateRef<any>) {
    this.modalFAC0008 = this.modalService.show(template, {
      class: ' w1240 modal-dialog-centered'
    });
  }
  openModalFAC0009(template: TemplateRef<any>) {
    this.modalFAC0009 = this.modalService.show(template, {
      class: ' w1240 modal-dialog-centered'
    });
  }
  openModalFAC0006(template: TemplateRef<any>) {
    this.modalFAC0006 = this.modalService.show(template, {
      class: ' w1240 modal-dialog-centered'
    });
  }
  openModalFAC0205(template: TemplateRef<any>) {
    this.modalFAC0205 = this.modalService.show(template, {
      class: ' w1240 modal-dialog-centered'
    });
  }
  onClose(value?: any): void {
    this.modalFAC0009.hide();
    this.modalFAC0006.hide();
    this.modalFAC0010.hide();
    this.modalFAC0008.hide();
  }

  getValue(obj: Observable<any>) {
    let value: any;
    obj.subscribe(v => value = v);
    return value;
  }
  ClosePop0205(value: any) {
    this.modalFAC0205.hide();
  }

  openPopQuestionareAnsInp() {
    this.PopQuestionareAnsInp = this.popupService.open(this.PopQuestionareAnsInpRef, {
      backdrop: 'static', keyboard: false, size: ' w1840', centered: true
    });
  }

  ResultPopQuestionareAnsInp(value) {
    this.PopQuestionareAnsInp.close();
    if (!value) {
    }
  }

  openModalFAC0404(template: TemplateRef<any>) {
    this.modalW1240 = this.modalService.show(template, {
      class: ' w640 modal-dialog-centered'
    });
  }
  openModalFAC0905(template: TemplateRef<any>) {
    this.modalW1240 = this.modalService.show(template, {
      class: ' w640 modal-dialog-centered'
    });
  }
}
